module.exports = __webpack_public_path__ + "img/group-outlet_mc.5eb6b36c.png";